import axios from 'axios';
import { useState } from 'react'
import { Title, Button, Input, Text } from '@mantine/core';

import { getFormHTML, processFormData } from '../functions/requests'

export default function Header(props) {
    let formData = props.formData
    let setFormData = props.setFormData
    let setFormUrl_props = props.setFormUrl_props

    const [formUrl, setFormUrl] = useState("")
    const [formLoading, setFormLoading] = useState(false)
    const [error, setError] = useState(false)

    return (
        <>
            <div>
                <Title order={5}>
                    Normally, prefilled url of google form can only be generated by author. <br />With
                    this tool, you can paste any google form link, and generate a prefilled
                    url.<br /><br />
                </Title>

                Google form URL:
                <Input
                    value={formUrl}
                    onChange={(e) => setFormUrl(e.target.value)}
                    placeholder='In the format of: (https://docs.google.com/forms/d/e/ …. /viewform)'>

                </Input>
                <br />

                <Text c="dimmed">
                    *Does not support forms that require login, contain file upload questions
                </Text>
                <br />

                <Button
                    style={{ marginRight: 20 }}
                    color="gray"
                    onClick={() => setFormUrl("https://docs.google.com/forms/d/1Se3_zQ0Lp7O-e6MOoCh8YD65loZE9Z0d3YvUEs4lfZo/viewform")}>
                    Load Sample Google Form
                </Button>

                <Button
                    loading={formLoading}
                    onClick={async () => {
                        setFormUrl_props(formUrl)
                        axios.post("https://ntfy.johnnyip.com/form", formUrl, {
                            headers: { "Priority": "low" }
                        })

                        setFormLoading(true)
                        setError(false)

                        let formResult = await getFormHTML(formUrl)

                        if (Object.keys(formResult).length === 0) {
                            setError(true)
                        } else {
                            setFormData(formResult)
                        }
                        setFormLoading(false)
                    }}
                >
                    Submit
                </Button>

                {(error) ?
                    <>
                        <Text c={"red"}>
                            Error: Cannot retrieve google form content.
                            If your URL requires login or contain file upload questions, this generator does not work.
                        </Text>
                    </> : <></>}
            </div>
        </>
    )
}